import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/electricidad-e-iluminaci-n-complete-service-page/page.tsx");
